import { Quaternion, Vector3 } from "three";
import Ammo from "ammojs-typed";
class MovementController {
    baseSpeed;
    /**
     * A movement controller for an entity.
     * This should be accessed through a character controller.
     * @param baseSpeed The entity's base speed.
     */
    constructor(baseSpeed) {
        this.baseSpeed = baseSpeed;
    }
    /**
     * Move the Entity according to the state of the input controller.
     * @private
     */
    move(inputController, rotation) {
        const forwardVelocity = (inputController.getFORWARD ? -1 : 0) + (inputController.getBACK ? 1 : 0);
        const strafeVelocity = (inputController.getLEFT ? -1 : 0) + (inputController.getRIGHT ? 1 : 0);
        if (forwardVelocity === 0 && strafeVelocity === 0)
            return new Ammo.btVector3(0, 0, 0);
        const velocity = new Vector3(strafeVelocity, 0, forwardVelocity);
        velocity.multiplyScalar(this.getSpeed());
        velocity.applyQuaternion(new Quaternion(rotation.x(), rotation.y(), rotation.z(), rotation.w()));
        return new Ammo.btVector3(velocity.x, 0, velocity.z);
    }
    /**
     * Calculate the speed at which the character should move.
     * @returns the calculated speed.
     * @private
     */
    getSpeed() {
        return this.baseSpeed;
    }
}
export default MovementController;
